import { CircleAlert, RefreshCw } from 'lucide-react';
import { getErrorMessage } from '@/lib/api-error';
import { Button } from '@/components/ui/Button';
import { useLogout } from './use-logout';

/**
 * Pantalla de error de sesión: se muestra cuando `GET /api/auth/me` falla por algo que NO
 * es un 401 (típicamente el backend está apagado o `VITE_API_URL` apunta mal). En vez de
 * dejar la pantalla en blanco, explica el problema y ofrece reintentar o salir.
 */
export function SessionErrorScreen({ error, onRetry }: { error: unknown; onRetry: () => void }) {
  const logout = useLogout();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-canvas px-4 text-center">
      <span className="flex size-12 items-center justify-center rounded-pill bg-danger-soft text-danger">
        <CircleAlert size={24} />
      </span>

      <div className="space-y-1">
        <h1 className="text-card-title font-semibold text-ink">No se pudo cargar tu sesión</h1>
        <p className="mx-auto max-w-md text-caption text-ink-muted">{getErrorMessage(error)}</p>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-2">
        <Button leftIcon={<RefreshCw size={16} />} onClick={onRetry}>
          Reintentar
        </Button>
        <Button variant="secondary" onClick={logout}>
          Cerrar sesión
        </Button>
      </div>
    </div>
  );
}
